import { Outlet } from "react-router-dom";

const QuotesParentPage = () => {
    return <Outlet />
}
export default QuotesParentPage;